import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { MwInputText, MwSelector, MwSelectorMulti, TagList } from "../../ui";
import { getDateNow } from "./../../../utils/utils/global";
import { useCurrent, useFetch } from "../../../hooks";
import PromoCodeBox from "../PromoCodeBox";
import { LuBanknote } from "react-icons/lu";

const InvFormHeader = ({
  invNo,
  setInvNo,
  invRef,
  invTitle,
  invTitleAr,
  invDate,
  invDateDue,
  invCurrency,
  customers,
  onClickNewCustomer,
  salesmans,
  onClickNewSalesman,
  customerSelected,
  setCustomerSelected,
  salesmanSelected,
  setSalesmanSelected,
  formErrors,
  setPriceListItems,
  priceListItems,
  productList,
  setProductList,
  SETTING_PRICE_INCLUDE_VAT,
  SETTING_INVOICE,
  netTotal,
  havePromoCode,
  setHavePromoCode,
  promoCodeHandler,
  discountOnchange,
  tagList,
  setTagList,
  promoCode,
  setPromoCode,
  taxesList,
  selectedCurrency,
  setSelectedCurrency,
  currencySymbol,
  setCurrencies,
  currencies,
}) => {
  const [t, i18next] = useTranslation("global");
  const lang = i18next.dir() === "rtl" ? "ar" : "en";
  const [titleLang, setTitleLang] = useState(lang);
  const [arValue, setArValue] = useState("");
  const [enValue, setEnValue] = useState("");

  const [showCurrencySelector, setShowCurrencySelector] = useState(false);

  const {
    data: fetchedData,
    loading,
    error,
    refreshHandler,
  } = useFetch(
    customerSelected && customerSelected.listPriceId
      ? `${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/inventory/list-price-items/${customerSelected.listPriceId}`
      : null,
    false,
  );

  console.log("productList By osamas", productList);

  // Add a function to format currencies for the selector
  const formatCurrenciesForSelector = () => {
    if (!currencies || currencies.length === 0) {
      return [];
    }

    return currencies.map((currency) => ({
      label: ` ${lang === "ar" ? currency.name_ar || currency.name_en : currency.name_en || currency.name_ar}`,
      value: currency.id,
      ...currency,
    }));
  };

  const areProductListsEqual = (currentList = [], nextList = []) => {
    if (!Array.isArray(currentList) || !Array.isArray(nextList)) return false;
    if (currentList.length !== nextList.length) return false;

    return currentList.every((item, idx) => {
      const next = nextList[idx];
      if (!next) return false;
      return (
        item?.productId === next?.productId &&
        Number(item?.qty || 0) === Number(next?.qty || 0) &&
        Number(item?.qtyDays || 0) === Number(next?.qtyDays || 0) &&
        Number(item?.priceUnit || 0) === Number(next?.priceUnit || 0) &&
        Number(item?.price || 0) === Number(next?.price || 0) &&
        Number(item?.productDiscount || 0) === Number(next?.productDiscount || 0) &&
        Number(item?.productNetTotal || 0) === Number(next?.productNetTotal || 0) &&
        Number(item?.productVat || 0) === Number(next?.productVat || 0) &&
        Number(item?.productNetTotalWithVat || 0) === Number(next?.productNetTotalWithVat || 0) &&
        String(item?.tax_id ?? "") === String(next?.tax_id ?? "") &&
        Number(item?.tax_rate || 0) === Number(next?.tax_rate || 0)
      );
    });
  };

  const handleArChange = (e) => {
    setArValue(e.target.value);
  };

  const handleEnChange = (e) => {
    setEnValue(e.target.value);
  };

  const date = new Date();
  const today = getDateNow().toLocaleDateString("en-CA"); // Get current date in the format 'YYYY-MM-DD'
  const todayAndTime = getDateNow().toLocaleDateString("en-CA");
  // +' '+date.toLocaleTimeString('it-IT'); // Get current date in the format 'YYYY-MM-DD'

  useEffect(() => {
    if (customerSelected && customerSelected.salesmanId) {
      const matchingSalesman = salesmans.find(
        (salesman) => salesman._id === customerSelected.salesmanId,
      );
      if (matchingSalesman) {
        setSalesmanSelected([
          {
            label:
              matchingSalesman?.fullname && matchingSalesman.fullname[1]
                ? matchingSalesman.fullname[1].text
                : "",
            value: matchingSalesman._id,
            ...matchingSalesman,
          },
        ]);
      }
    } else {
      setSalesmanSelected([]);
    }
  }, [customerSelected, salesmans, setSalesmanSelected]);

  // ADDD NEW USE EFFECT TO HANDLE NEW TAX
  useEffect(() => {
    if (customerSelected && customerSelected.listPriceId) {
      const defaultPriceList = productList.map((product) => {
        if (
          product.productId === "section" ||
          !product.productId ||
          product.productId === "0"
        ) {
          return product;
        }

        // احسب السعر باستخدام الإعداد الافتراضي للضريبة
        const defaultPrice =
          SETTING_PRICE_INCLUDE_VAT === "true"
            ? parseFloat(product.originalPriceUnit) || 0
            : parseFloat(product.originalPriceUnit) || 0;

        // استخدم معدل الضريبة من الإعدادات أو من الضرائب المحددة
        const taxRate =
          taxesList.length > 0
            ? taxesList[0]?.rate || SETTING_INVOICE?.INV_VAT_PERCENT || 15
            : SETTING_INVOICE?.INV_VAT_PERCENT || 15;

        return {
          ...product,
          priceUnit: defaultPrice,
          price: product.qty * defaultPrice * (product.qtyDays || 1),
          productNetTotal: product.qty * defaultPrice * (product.qtyDays || 1),
          productVat:
            (product.qty * defaultPrice * (product.qtyDays || 1) * taxRate) /
            100,
          productNetTotalWithVat:
            product.qty *
            defaultPrice *
            (product.qtyDays || 1) *
            (1 + taxRate / 100),
        };
      });

      setPriceListItems([]);
      if (!areProductListsEqual(productList, defaultPriceList)) {
        setProductList(defaultPriceList);
      }
    }
  }, [customerSelected, taxesList]);

  useEffect(() => {
    if (fetchedData && fetchedData.data) {
      setPriceListItems(fetchedData.data);

      if (
        productList &&
        productList.length > 0 &&
        customerSelected &&
        customerSelected.listPriceId
      ) {
        const updatedProductList = [...productList];

        updatedProductList.forEach((product, idx) => {
          if (
            product.productId === "section" ||
            !product.productId ||
            product.productId === "0"
          ) {
            return;
          }

          const priceListItem = fetchedData.data.find(
            (item) => item.product_id.trim() === product.productId,
          );

          if (priceListItem) {
            const newPrice =
              SETTING_PRICE_INCLUDE_VAT === "true"
                ? parseFloat(priceListItem.product_sale_price)
                : parseFloat(priceListItem.product_sale_price);

            product.priceUnit = newPrice;

            product.price = product.qty * newPrice * (product.qtyDays || 1);

            if (
              product.productDiscount &&
              product.productDiscount.includes("%")
            ) {
              product.productNetTotal =
                parseFloat(product.price) -
                (parseFloat(product.price) *
                  parseFloat(product.productDiscount.replace("%", ""))) /
                  100;
            } else {
              product.productNetTotal =
                product.price - (product.productDiscount || 0);
            }

            const vatPercent = SETTING_INVOICE?.INV_VAT_PERCENT || 15;
            product.productVat =
              ((product.productNetTotal || 0) * vatPercent) / 100;
            product.productNetTotalWithVat =
              product.productVat + (product.productNetTotal || 0);
          }
        });

        if (!areProductListsEqual(productList, updatedProductList)) {
          setProductList([...updatedProductList]);
        }
      }
    }
  }, [fetchedData, customerSelected]);

  return (
    <>
      <div className="flex flex-col gap-2 md:flex-row justify-between  items-center ">
        <div className="flex w-full md:w-fit gap-2 ">
          <div className="flex-1 md:w-24   ">
            <MwInputText
              label={t("quotes.quoteNumber")}
              id="inv_no"
              value={invNo}
              disabled={true}
              onChange={(e) => setInvNo(e.target.value)}
            />
          </div>
          <div className="flex-1 md:w-20">
            <MwInputText
              label={t("invoice.invoiceRef")}
              inputRef={invRef}
              id="inv_ref"
              defaultValue=""
            />
          </div>
        </div>
        <div className="flex  gap-2 w-full md:w-fit ">
          <div className="flex-1 md:w-38 ">
            <MwInputText
              label={t("quotes.creationDate")}
              inputType="date"
              inputRef={invDate}
              id="inv_date"
              defaultValue={todayAndTime}
              invalid={!!formErrors?.invDate}
              disabled={false}
              // invalidMsg={formErrors?.invDate}
            />
          </div>
          <div className="flex-1 md:w-28">
            <MwInputText
              label={t("quotes.expirationDate")}
              inputType="date"
              inputRef={invDateDue}
              id="inv_date_due"
              defaultValue={today}
              invalid={!!formErrors?.invDateDue}
            />
          </div>
        </div>
        <div className="relative flex w-full items-center gap-1">
          <div className="flex-1">
            <div className="flex justify-between items-center ">
              <span className="text-[#251658] text-xs">
                {titleLang === "ar"
                  ? t("invoice.invTitleAr")
                  : t("invoice.invTitle")}
              </span>
              <button
                onClick={() => setTitleLang(titleLang === "ar" ? "en" : "ar")}
                type="button"
                className="px-2 py-0.5 mb-1 text-xs bg-[#251658] text-white rounded hover:bg-[#251658]/80"
              >
                {titleLang === "ar" ? "EN" : "AR"}
              </button>
            </div>
            <div className={titleLang === "ar" ? "" : "hidden"}>
              <MwInputText
                inputRef={invTitleAr}
                id="inv_title_ar"
                value={arValue}
                placeholder="اسم المشروع"
                onChange={handleArChange}
                dir="rtl"
              />
            </div>
            <div className={titleLang === "ar" ? "hidden" : ""}>
              <MwInputText
                inputRef={invTitle}
                id="inv_title"
                value={enValue}
                placeholder="Project Name"
                onChange={handleEnChange}
                dir="ltr"
              />
            </div>
          </div>

          <div className="flex-1">
            <MwSelector
              label={t("invoice.selectCustomer")}
              initalValue={`${t("invoice.selectCustomer")}...`}
              _data={customers}
              dataType="customer"
              onClickNew={onClickNewCustomer}
              selectedItem={customerSelected}
              setSelectedItem={setCustomerSelected}
              invalid={!!formErrors?.customerSelected}
            />
          </div>

          <div className="flex-1">
            <MwSelector
              initalValue={`${t("invoice.selectSalesman")}...`}
              label={t("invoice.selectSalesman")}
              _data={salesmans}
              dataType="salesman"
              onClickNew={onClickNewSalesman}
              selectedItem={salesmanSelected}
              setSelectedItem={setSalesmanSelected}
            />
          </div>

          <div className="w-36 relative">
            {!showCurrencySelector && !selectedCurrency?.length ? (
              <button
                onClick={() => setShowCurrencySelector(true)}
                className="w-full h-full mt-6 max-h-[30px] flex items-center justify-center gap-2 p-2 border border-gray-300 rounded-md hover:bg-blue-50 text-[#251658] text-xs transition-all duration-300"
              >
                <svg
                  className="w-4 h-4 animate-bounce"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <LuBanknote />
                </svg>
                <span className="font-bold ">{currencySymbol}</span>
              </button>
            ) : (
              <MwSelector
                label={lang === "ar" ? "العملة" : "Main"}
                _data={formatCurrenciesForSelector()}
                dataType="labelValue"
                setSelectedItem={(value) => {
                  setSelectedCurrency(value);
                }}
                selectedItem={selectedCurrency}
                initalValue={lang === "ar" ? "اختر العملة" : "Select Currency"}
                withSearch={false}
                withLabel={false}
                withAddNew={false}
              />
            )}
          </div>
        </div>
      </div>
      <div className=" grid grid-cols-2 gap-2 my-2 justify-between ">
        <TagList tagList={tagList} setTagList={setTagList} />
        <PromoCodeBox
          havePromoCode={havePromoCode}
          setHavePromoCode={setHavePromoCode}
          promoCode={promoCode}
          setPromoCode={setPromoCode}
          promoCodeHandler={promoCodeHandler}
        />
      </div>
    </>
  );
};

export default InvFormHeader;
